<template>
  <div>
    <div class="flex justify-center py-52">
      <div>
        <div class="loading-stack loading-stack__1" />
        <div class="loading-stack loading-stack__2" />
        <div class="loading-stack loading-stack__3" />
        <div class="loading-stack loading-stack__4" />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @keyframes changecolor {
    0% {
      background-color: #55881b;
    }

    1% {
      background-color: #55881b;
    }

    15% {
      background-color: #55881b;
    }

    21% {
      background-color: #4169e1;
    }

    35% {
      background-color: #4169e1;
    }

    41% {
      background-color: #e69002;
    }

    55% {
      background-color: #e69002;
    }

    61% {
      background-color: #306c9a;
    }

    75% {
      background-color: #306c9a;
    }

    81% {
      background-color: #6daee0;
    }

    95% {
      background-color: #6daee0;
    }

    100% {
      background-color: #55881b;
    }
  }

  @keyframes animation__stack-1 {
    0% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    10% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    30% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(44px);
    }

    50% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    57% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-28px);
    }

    64% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    100% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(135deg)
        translateZ(-36px);
    }
  }

  @keyframes animation__stack-2 {
    0% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    10% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    30% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(28px);
    }

    50% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    57% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-29.6px);
    }

    64% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    100% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(135deg)
        translateZ(-36px);
    }
  }

  @keyframes animation__stack-3 {
    0% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    10% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    30% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(12px);
    }

    50% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    57% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-31.2px);
    }

    64% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    100% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(135deg)
        translateZ(-36px);
    }
  }

  @keyframes animation__stack-4 {
    0% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    10% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    30% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(0px);
    }

    50% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    57% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-32.4px);
    }

    64% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(45deg)
        translateZ(-36px);
    }

    100% {
      transform: perspective(2400px) rotateX(60deg) rotateZ(135deg)
        translateZ(-36px);
    }
  }

  .loading-stack {
    width: 50px;
    height: 50px;
    margin-top: -50px;
    border-radius: 6px;
    transform-origin: center;
    will-change: transform;
    animation-delay: -2s;
    animation-duration: 2s, 10s;
    animation-iteration-count: infinite, infinite;
    animation-timing-function: ease, ease;
  }

  .loading-stack__1 {
    opacity: 1;
    animation-name: animation__stack-1, changecolor;
  }

  .loading-stack__2 {
    opacity: 0.75;
    animation-name: animation__stack-2, changecolor;
  }

  .loading-stack__3 {
    opacity: 0.5;
    animation-name: animation__stack-3, changecolor;
  }

  .loading-stack__4 {
    opacity: 0.25;
    animation-name: animation__stack-4, changecolor;
  }
</style>
